import gql from 'graphql-tag';

export default gql`
  fragment rankChangeProspectActivityFragment on RankChangeProspectActivity {
    rank
    rankText
  }
`;
